/**
 * Locale-aware display helpers for fiscal-year labels.
 *
 * The backend stores `fy_label` as English ("FY2026") at workspace-create
 * time — a frozen snapshot useful for audit history. For *display*, we
 * want to honor the viewer's current language, which is a client-side
 * concern. Hence: this tiny helper, used wherever a workspace fyLabel
 * appears in the UI.
 *
 *   - `ja` → `2026年度` (nendo, the JP fiscal-year convention)
 *   - everything else → `FY2026`
 *
 * `displayFyYear` is for the collapsed-sidebar variant where space is
 * tight and we only want the bare year token (`2026年度` in ja, `2026`
 * elsewhere — matching the existing English `.replace('FY','')` trim).
 */

const YEAR_RE = /(?:FY)?(\d{4})/;

export function displayFy(storedLabel: string | null | undefined, locale: string | undefined): string {
  if (!storedLabel) return '';
  const m = YEAR_RE.exec(storedLabel);
  if (!m) return storedLabel;
  const year = m[1];
  return isJa(locale) ? `${year}年度` : `FY${year}`;
}

export function displayFyYear(storedLabel: string | null | undefined, locale: string | undefined): string {
  if (!storedLabel) return '';
  const m = YEAR_RE.exec(storedLabel);
  if (!m) return storedLabel;
  const year = m[1];
  return isJa(locale) ? `${year}年度` : year;
}

function isJa(locale: string | undefined): boolean {
  return !!locale && locale.toLowerCase().startsWith('ja');
}
